import axios from "axios";
import React, { useEffect, useState } from "react";
import LoadingSpinner from "../customComponents/LoadingSpinner";

export default function AdminPanelView() {
    const [isLoading, setIsLoading] = useState(false);
    const [allStats, setAllStats] = useState([]);

    useEffect(() => {
        getStats();
    }, []);

    function getStats() {
        setIsLoading(true);

        axios
            .get("apm/stats")
            .then((response) => {
                setIsLoading(false);
                console.log(response.data);
                setAllStats(response.data);
            })
            .catch((error) => {
                setIsLoading(false);
            });
    }
    return (
        <div className="container">
            <div className="d-flex justify-content-center">
                Admin Panel View
            </div>
            <div className="container mt-5">
                <div className="d-flex flex-column justify-content-center">
                    <h5 className="text-center">Bugs In Site Stats</h5>
                    <div className="text-center">
                        {isLoading && <LoadingSpinner height={40} width={40} />}
                    </div>
                </div>
                <div className="col-12 d-flex flex-column">
                    <div className="d-flex justify-content-around">
                        <h4>
                            Unique Views: {isLoading ? "-" : allStats.statsUser}
                        </h4>
                        <h4>
                            Total Views: {isLoading ? "-" : allStats.statsUserVisit}
                        </h4>
                    </div>
                </div>
            </div>
        </div>
    );
}
